// extracted by mini-css-extract-plugin
export var inputWrapper = "SearchInput-module--input-wrapper--21dec";